/* eslint-disable camelcase */
import React from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { selectBoothById } from 'models/cms/booths';

import useBoothEnterTracking from './useBoothEnterTracking';
import BoothPageContentContainer from './BoothPageContentContainer';

const BoothPageContainerEffects = () => {
  const { boothId } = useParams<any>();
  const booth = useSelector((state) => selectBoothById(state, boothId));

  useBoothEnterTracking(booth);

  return null;
};

const BoothPageContainer = () => (
  <>
    <BoothPageContainerEffects />
    <BoothPageContentContainer />
  </>
);

export default React.memo(BoothPageContainer);
